import request from '@/utils/request'

export function getUserDetailApi() {
  return request({
    url: '/auth-service/v1/user-info',
    method: 'get'
  })
}

export function userUpdatePasswordApi(payload) {
  return request({
    url: '/config-service/v1/account/update-password-by-user',
    method: 'put',
    data: payload
  })
}
